module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/422.ea2038e7.png";